const SETTING_NAMES = ['contentId', 'title', 'headerTitle', 'link', 'backgroundSettings', 'headerLink']

export default {
  inheritAttrs: false,
  props: {
    /**
     * The id of the section
     */
    contentId: {
      type: String,
      default: null
    },
    /**
     * Title of the section
     */
    title: {
      type: String,
      default: ''
    },
    /**
     * headerTitle of the section
     */
    headerTitle: {
      type: String,
      default: null
    },
    /**
     * Show link in combination with headerTitle of the section
     */
    link: {
      type: Object,
      default: null
    },
    /**
     * headerLink of the section
     */
    headerLink: {
      type: Object,
      default: null
    },
    /**
     * Module setting: The background settings of the module
     */
    backgroundSettings: {
      type: Object,
      default: null
    }
  },
  computed: {
    moduleProps () {
      return SETTING_NAMES.reduce((settings, propName) => {
        if (this[propName]) {
          settings[propName] = this[propName]
        }

        return settings
      }, {})
    },
    cardBackground () {
      return this.backgroundSettings?.backgroundColor === 'beige'
        ? 'white'
        : 'beige'
    }
  }
}
